var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.item.config)?_c('section',_vm._l((_vm.eventData),function(event,index){return _c('InfoBranch',{key:("purchased-event-" + index),style:({
      marginTop: '2px',
    }),attrs:{"content":event.name,"description":event.location}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }